import React, {useState} from 'react'
import authContext from './authContext'
import axios from 'axios'


const AuthState = props => {


    const [auth, setAuth] = useState({

        loading: "d-flex",
        farmTypes: [],
        farmStates: [],
        farmLgas: [],
        userInfo: null,
        error: null,
        message: {
            msg: "",
            msg_options: ""
        },
        logged_in: localStorage.getItem('al2'),
        side_bar_toggle: ""
        // logged_in: false
    })

    const url = 'https://hailing-backend-app.azurewebsites.net/';
    // const url = 'https://hailing-backend.herokuapp.com/';
    // const url = 'http://127.0.0.1:9900/';
    //Token
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let authorization;
    if(userInfo !== null) authorization = userInfo.authorization

    //Set up axios headers
    const authAxios = axios.create({
        headers: {
            'Content-Type': 'multipart/form-data',
            'authorization': authorization
        },
        validateStatus: () => true
    })

    const register = async (user) => {
        try {
            return await authAxios.post(
                url + 'auth/signup',
                user
            ).then(res => {
                if (res.request.status === 201) {

                    setAuth({
                        ...auth,
                        loading: false,
                        message: {
                            msg: `${JSON.parse(res.request.response).message}`,
                            msg_options: {
                                type: 'success',
                                position: "top left"
                            }
                        }
                    })
                } else {
                    setAuth({
                        ...auth,
                        loading: false,
                        message: {
                            msg: `${JSON.parse(res.request.response).message}`,
                            msg_options: {
                                type: 'error',
                                position: "top left",
                            }
                        }
                    })
                }
                return res;
            })
        } catch (res) {
            if (res.request.status === 0) {
                setAuth({
                    ...auth,
                    loading: false,
                    message: {
                        msg: 'network error, please check your internet connection!',
                        msg_options: {
                            type: 'error',
                            position: "bottom left"
                        }
                    }
                })
            }

            return res;
        }
    }

    const login = async (user_data) => {
        try {
            return await authAxios.post(
                url + 'auth/user/login',
                user_data,
            ).then(res => {
                if (res.request.status === 200) {

                    localStorage.setItem('al2', 1);
                    localStorage.setItem('userInfo', JSON.stringify(res.data.data));

                    setAuth({
                        ...auth,
                        loading: false,
                        userInfo: res.data.data,
                        logged_in: true,
                        message: {
                            msg: "Login successful!",
                            msg_options: {
                                type: 'success',
                                position: "bottom right"
                            }
                        }
                    })

                } else {

                    setAuth({
                        ...auth,
                        loading: false,
                        message: {
                            msg: `${JSON.parse(res.request.response).data}`,
                            msg_options: {
                                type: 'error',
                                position: "top left",
                            }
                        }
                    })
                }
                return res;

            }).catch(res => {
                if (res.request.status === 0) {
                    setAuth({
                        ...auth,
                        loading: false,
                        message: {
                            msg: 'network error, please check your internet connection!',
                            msg_options: {
                                type: 'error',
                                position: "bottom left"
                            }
                        }
                    })
                }
                return res;
            })


        } catch (error) {
            setAuth({
                ...auth,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
            return error;
        }
    }

    const logout = async () => {
        localStorage.removeItem('userInfo')
        localStorage.removeItem('al2')

        setAuth({
            ...auth,
            message: {
                msg: "Logged out successfully!",
                msg_options: {
                    type: 'success',
                    position: "bottom right"
                }
            },
            logged_in: false
        })
    }

    const activate_account = async (user_data) => {
        try {
            return await authAxios.get(
                url + 'auth/user/activate_account/' + user_data,
            ).then(res => {
                setAuth({
                    ...auth,
                    loading: false,
                })
                return res;
            }).catch(res => {
                if (res.request.status === 0) {
                    setAuth({
                        ...auth,
                        loading: false,
                        message: {
                            msg: 'network error, please check your internet connection!',
                            msg_options: {
                                type: 'error',
                                position: "bottom left"
                            }
                        }
                    })
                }
                return res;
            })


        } catch (error) {
            setAuth({
                ...auth,
                loading: false,
                error: error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
            })
            return error;
        }
    }


    const clearAlert = () => {
        setAuth({
            ...auth,
            message: {
                msg: "",
                msg_options: {
                    type: '',
                    position: ""
                }
            }
        })
    }

    const toggle_sidebar = () => {
        if (auth.side_bar_toggle === "") {
            setAuth({
                ...auth,
                side_bar_toggle: "toggled"
            })
        } else {
            setAuth({
                ...auth,
                side_bar_toggle: ""
            })
        }

    }

    //Set Loading
    const setLoading = () => {
        setAuth({
            ...auth,
            loading: true,
        })
    }
    const clearPageLoading = () => {
        setAuth({
            ...auth,
            loading: "d-none",
        })
    }
    return <authContext.Provider
        value={{
            auth,
            login,
            register,
            activate_account,
            logout,
            clearAlert,
            clearPageLoading,
            setLoading,
            toggle_sidebar
        }}>
        {props.children}
    </authContext.Provider>
}

export default AuthState;